/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import cx from 'classnames';
import T from 'i18n-react';
import Router from 'next/router';

import { Button } from '@motorway/mw-highway-code';

import texts from '../../../texts.json';

import styles from '../StaticContents.module.scss';

T.setTexts(texts);

const phone = T.translate('contactInfo.phone');

const ErrorPage = ({ button = true }: { button?: boolean }) => (
	<div className={cx(styles.staticContents, styles.container, styles.center)}>
		<h1>{T.translate('500.title')}</h1>
		<div>
			<p>
				{T.translate('500.body', {
					phone: <a href={`tel:${String(phone).replace(/ /g, '')}`}>{phone}</a>,
				})}
			</p>
		</div>
		<br />
		{button && <Button fullWidth icon="chevron" label="Back" onClick={() => Router.reload()} />}
	</div>
);

export default ErrorPage; // can't use Error as it's JS constructor
